<template>
  <div class="analysis-summary-card">
    <div class="summary-header">
      <div class="summary-icon" :class="'summary-icon-' + parsedStatus">
        <svg v-if="parsedStatus === 'warning'" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zm-1 5v4h2v-4h-2zm0 6v2h2v-2h-2z"/>
        </svg>
        <svg v-else-if="parsedStatus === 'success'" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
        <svg v-else-if="parsedStatus === 'error'" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
        </svg>
        <svg v-else viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
        </svg>
      </div>
      <div class="summary-content">
        <div class="summary-title">{{ title }}</div>
        <div class="summary-points" v-if="parsedPoints.length > 0">
          <div v-for="(point, idx) in parsedPoints" :key="idx" class="summary-point">
            {{ point }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalysisSummary',
  props: {
    title: { type: String, default: '' },
    status: { type: String, default: 'warning' },
    points: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedStatus() {
      const validStatuses = ['success', 'warning', 'info', 'error']
      return validStatuses.includes(this.status) ? this.status : 'warning'
    },
    parsedPoints() {
      if (Array.isArray(this.points)) return this.points
      if (typeof this.points === 'string') {
        try {
          const parsed = JSON.parse(this.points)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.analysis-summary-card {
  max-width: 800px;
  padding: 16px;
  background: #fff;
  border: 1px solid #4A5FF3;
  border-radius: 8px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.summary-header {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.summary-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.summary-icon-success {
  color: #22c55e;
}

.summary-icon-warning {
  color: #f59e0b;
}

.summary-icon-info {
  color: #3b82f6;
}

.summary-icon-error {
  color: #ef4444;
}

.summary-content {
  flex: 1;
  min-width: 0;
}

.summary-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.6;
  margin-bottom: 8px;
}

.summary-points {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-point {
  font-size: 12px;
  color: #475569;
  line-height: 1.7;
}
</style>
